var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33.4286L40 17L63 33.4286V37.9464H56.0465V63H23.9535V37.9464H17V33.4286Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2395 44.143L36.7856 41.5715L30.9999 51.5927L34.5126 50.6515L35.4538 54.1641L41.2395 44.143Z",
    fill: "white",
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1682 41.5714L38.7144 44.1428L44.5001 54.164L45.4413 50.6513L48.9539 51.5925L43.1682 41.5714Z",
    fill: "white",
    stroke: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4385 30.6468L40 30.5021L41.5615 30.6468L43.0698 31.076L44.4735 31.775L45.725 32.72L46.7814 33.8789L47.607 35.2122L48.1735 36.6745L48.4616 38.2159V39.7841L48.1735 41.3255L47.607 42.7878L46.7814 44.1211L45.725 45.28L44.4736 46.225L43.0698 46.924L41.5615 47.3532L40 47.4979L38.4385 47.3532L36.9302 46.924L35.5264 46.225L34.275 45.28L33.2186 44.1211L32.393 42.7878L31.8265 41.3255L31.5384 39.7841V38.2159L31.8265 36.6745L32.393 35.2122L33.2186 33.8789L34.275 32.72L35.5265 31.775L36.9302 31.076L38.4385 30.6468Z",
    fill: "white",
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFacility);
export default __webpack_public_path__ + "static/media/New_facility.7a617b897c6e629c1f65de2c5e170611.svg";
export { ForwardRef as ReactComponent };